import { adminUserApi } from '../apis';
import NavigationService from '../routers/NavigationService';
import { baseUrl } from '../config/baseUrl';

class AdminUserService {
  async signIn(data) {
    const rs = await adminUserApi.signIn(data);
    return rs;
  }

  async verifyToken() {
    const rs = await adminUserApi.verifyToken();
    return rs;
  }

  async updateTrafficStatus(data) {
    const rs = await adminUserApi.updateTrafficStatus(data);
    return rs;
  }
  
  async speechReport(data) {
    const rs = await adminUserApi.speechReport(data);
    return rs;
  }

  signOut() {
    localStorage.removeItem('token');
    NavigationService.navigate(`${baseUrl}admin/sign-in`);
  }

  async getAllRegisterHealthFacilities(){
    const rs = await adminUserApi.getAllRegisterHealthFacilities();
    return rs;
  }

  async getLicenseImage(license_img){
    const rs = await adminUserApi.getLicenseImage(license_img);
    return rs;
  }

  async updateRegisterState(_id,newState){
    const rs = await adminUserApi.updateRegisterState(_id,newState);
    return rs;
  }

  async createHealthFacility(data){
    const rs = await adminUserApi.createHealthFacility(data);
    return rs;
  }
}

const adminUserService = new AdminUserService();

export default adminUserService;
